import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Insurance from "./Components/Insurance";
import LandPackage from "./Components/LandPackage";
import Misc from "./Components/Misc";
import HotelForm from "./Components/HotelForm";
import Cruise from "./Components/Cruise";
import InvoiceDetailsForm from "./Components/InvoiceDetailsFrom";
import AirTicket from "./Components/AirTicket";
import InputField from "components/fields/InputField";
import { FaMinus, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import Documentation from "./Components/Documentation";
import userResources from "api/userResources";
import CustomerDetails from "./Components/CustomerDetails";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import { selectUserInfo } from "../../../redux/userSlice";
import { useSelector } from "react-redux";

const ticketItems = [
  { name: "Air Ticket", link: "/admin/create-new-invoice/air-ticket" },
  { name: "Insurance", link: "/admin/create-new-invoice/insurance" },
  { name: "Land Package", link: "/admin/create-new-invoice/land-package" },
  { name: "Cruise", link: "/admin/create-new-invoice/cruise" },
  { name: "Hotel", link: "/admin/create-new-invoice/hotel" },
  { name: "Misc", link: "/admin/create-new-invoice/misc" },
];

export default function CreateNewInvoice() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector(selectUserInfo);
  const currentParam = params["*"];
  const [employeeData, setEmployeeData] = useState([]);
  const [insurance, setInsurance] = useState(false);
  const [landPackage, setLandPackage] = useState(false);
  const [cruise, setCruise] = useState(false);
  const [hotelForm, setHotelForm] = useState(false);
  const [misc, setMisc] = useState(false);
  const [disable, setDisabled] = useState(false);

  const updateData = location?.state?.data;

  const recordId = location?.state?.recordId;

  // Initialize the form with useForm

  const getEmployye = async () => {
    try {
      const response = await userResources.adminemployeeslist();

      const data = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setEmployeeData(data);
      if (!updateData) {
        setValue("sales_agent_id", userInfo.data.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Define your default values separately
  const defaultPassengerDetails = [
    {
      first_name: "",
      last_name: "",
      title: "",
      add_insurance: false,
      bill_to: false, // First passenger defaults to bill_to true
    },
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
    getValues,
    setError,
    clearErrors,
    control, // For passing to useFieldArray
  } = useForm({
    // mode: "onBlur",
    defaultValues: {
      invoice_id: recordId,
      customer_details: {
        full_name: "",
        email: "",
        phone_number: "",
        alternate_phone: "",
        address: "",
        country_id: "",
        state_id: "",
        city_id: "",
        postal_code: "",
        passport_number: "",
      },
      airticket: {
        passenger_details: defaultPassengerDetails,
        passengers: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        // New customer_details section with all keys from CustomerDetails
        flight_details: [
          {
            airline: null,
            from: "",
            to: "",
            date: "",
            flight_no: "",
            dep_time: "",
            arr_time: "",
          },
        ],
        airticket_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          gstHst: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          amountPaid: 0,
          transation_type_id: null,
          commission: null,
          payment_received_from_pax: false,
          // bill_to: false,
        },
        airticket_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          gstHst: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          paymentMade: 0,
          payment_received_from_supplier: 0,
          commission_from_supplier: false,
        },
      },
      insurance: {
        insurance_passenger_details: [
          // { first_name: "", last_name: "" }, // default entry flagged
        ],
        passengers: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        insurance_details: {
          insurance_provider: "",
          policy_number: "",
          effective_date: "",
          termination_date: "",
          amount_insured: "",
          insurance_plan: "",
        },
        insurance_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          amountPaid: 0,
          transation_type_id: null,
          commission: null,
          payment_received_from_pax: false,
        },
        insurance_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          paymentMade: 0,
          payment_received_from_supplier: 0,
          commission_from_supplier: false,
        },
      },
      land_package: {
        landPackageDetails: {
          package_name: "",
          country: "",
          start_date: "",
          end_date: "",
          operator: "",
        },
        passengers: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        landpackage_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          commission: null,
        },
        landpackage_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          paymentMade: 0,
          payment_received_from_supplier: 0,
          commission_from_supplier: false,
        },
      },
      cruise: {
        cruiseDetails: {
          cruise_name: "",
          country: null,
          start_date: "",
          end_date: "",
          operator: "",
        },
        passengers: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        cruise_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          commission: null,
        },
        cruise_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          paymentMade: 0,
          payment_received_from_supplier: 0,
          commission_from_supplier: false,
        },
      },
      hotel: {
        hotelDetails: {
          hotel_name: "",
          country: "",
          start_date: "",
          end_date: "",
          operator: "",
        },
        passengers: {
          adt: 1,
          chd: 0,
          inf: 0,
        },
        hotel_from_pax: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          commission: null,
        },
        hotel_to_supplier: {
          baseFare: { adt1: null, chd1: null, inf1: null },
          taxes: { adt1: null, chd1: null, inf1: null },
          subTotal: { adt1: 0, chd1: 0, inf1: 0 },
          total: 0,
          transation_type_id: null,
          paymentMade: 0,
          payment_received_from_supplier: 0,
          commission_from_supplier: false,
        },
      },
      misc: {
        supplier_id: "",
        amount: "",
        invoice_details: "",
      },
    },
  });

  // Handle passengers array (under "airticket.passenger_details")
  const {
    fields: passengerFields,
    append: appendPassenger,
    remove: removePassenger,
  } = useFieldArray({
    control,
    name: "airticket.passenger_details",
  });

  // Handle flight details array (under "airticket.flight_details")
  const {
    fields: flightFields,
    append: appendFlight,
    remove: removeFlight,
  } = useFieldArray({
    control,
    name: "airticket.flight_details",
  });

  // Handle insurance passenger details array (under "insurance.insurance_passenger_details")
  const {
    fields: insuranceFields,
    append: appendInsurance,
    remove: removeInsurance,
  } = useFieldArray({
    control,
    name: "insurance.insurance_passenger_details", // Updated to match defaultValues
  });

  // Recursive function to collect error messages
  const collectErrorMessages = (errorsObj) => {
    let messages = [];
    Object.entries(errorsObj).forEach(([key, value]) => {
      if (value?.message) {
        messages.push(value.message);
      } else if (typeof value === "object" && value !== null) {
        messages = messages.concat(collectErrorMessages(value));
      }
    });
    return messages;
  };

  // Function to show errors via toast
  const showErrorsToast = (errorsObj) => {
    const messages = collectErrorMessages(errorsObj);
    if (messages.length > 0) {
      toast.error(messages.join(", "));
    }
  };

  const onError = async (errors) => {
    showErrorsToast(errors);
  };
  const onSubmit = async (data) => {
    setDisabled(true);
    try {
      let payload = {};

      // If we're in misc mode, only send the misc object.
      if (currentParam === "create-new-invoice/misc") {
        payload = {
          misc: data.misc,
          customer_details: data?.customer_details,
          misc_include: data?.misc_include,
          sales_agent_id: userInfo?.data?.id,
        };
      } else {
        // For all non-misc invoices, send all extra fields
        // (fields that are not one of the nested objects) from data.
        const excludedKeys = [
          "airticket",
          "insurance",
          "land_package",
          "cruise",
          "hotel",
          "misc",
        ];
        Object.keys(data).forEach((key) => {
          if (!excludedKeys.includes(key)) {
            payload[key] = data[key];
          }
        });

        // Depending on the current invoice type, add the corresponding object(s)
        switch (currentParam) {
          case "create-new-invoice/air-ticket":
            payload.airticket = data.airticket;
            if (insurance) payload.insurance = data.insurance;
            if (landPackage) payload.land_package = data.land_package;
            if (cruise) payload.cruise = data.cruise;
            if (hotelForm) payload.hotel = data.hotel;
            if (misc) payload.misc = data.misc;
            break;
          case "create-new-invoice/insurance":
            payload.insurance = data.insurance;
            break;
          case "create-new-invoice/land-package":
            payload.land_package = data.land_package;
            break;
          case "create-new-invoice/cruise":
            payload.cruise = data.cruise;
            break;
          case "create-new-invoice/hotel":
            payload.hotel = data.hotel;
            break;
          // Add other currentParam cases as needed.
          default:
            break;
        }
      }
      // Use the payload in your API call:
      // For example, if userResources.createNewInvoice is a function, call it with the payload.
      const response = await userResources.createNewInvoice(payload);
      console.log(response);

      toast.success(
        updateData
          ? "Invoice updated successfully!"
          : "Invoice submitted successfully!"
      );

      // Optionally, reset the form:
      reset();
      navigate("/admin/total-invoice");
      setDisabled(false);
    } catch (error) {
      // Check if Laravel sent validation errors
      if (error.response && error.response.data) {
        const { message, errors } = error.response.data;

        // Show main message
        // if (message) toast.error(message);

        // Optionally show field-specific errors
        if (errors) {
          Object.values(errors).forEach((fieldErrors) => {
            // fieldErrors is an array (e.g., ["The selected supplier id is invalid."])
            fieldErrors.forEach((msg) => toast.error(msg));
          });
        }
      } else {
        // Fallback for network or unexpected errors
        toast.error("Something went wrong. Please try again.");
      }
      setDisabled(false);
    }
    setDisabled(false);
  };

  useEffect(() => {
    reset();
  }, [currentParam]);

  useEffect(() => {
    setInsurance(false);
    setLandPackage(false);
    setCruise(false);
    setHotelForm(false);
    setMisc(false);
  }, [currentParam]);

  // Watch the passenger_details array from the form values
  // Watch the entire passenger_details array
  const passengerDetails = watch("airticket.passenger_details");

  // Use an effect that only runs when add_insurance values change
  useEffect(() => {
    if (updateData) return; // If updateData exists, don't subscribe
    // Subscribe to form value changes
    const subscription = watch((value, { name }) => {
      // Check if the changed field is one of the add_insurance fields
      if (name && name.includes("add_insurance")) {
        const passengerDetails = value.airticket.passenger_details;
        const anyInsurance = passengerDetails.some(
          (passenger) => passenger.add_insurance
        );
        setInsurance(anyInsurance);
      }
    });

    // Unsubscribe when component unmounts
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    const includeSettings = [
      {
        field: "airticket_include",
        isActive: currentParam === "create-new-invoice/air-ticket",
      },
      {
        field: "insurance_include",
        isActive: insurance || currentParam === "create-new-invoice/insurance",
      },
      {
        field: "land_package_include",
        isActive:
          landPackage || currentParam === "create-new-invoice/land-package",
      },
      {
        field: "cruise_include",
        isActive: cruise || currentParam === "create-new-invoice/cruise",
      },
      {
        field: "hotel_include",
        isActive: hotelForm || currentParam === "create-new-invoice/hotel",
      },
      {
        field: "misc_include",
        isActive: misc || currentParam === "create-new-invoice/misc",
      },
    ];

    includeSettings.forEach(({ field, isActive }) => {
      setValue(field, isActive);
    });
  }, [currentParam, insurance, landPackage, cruise, hotelForm, misc]);

  // Watch the entire passenger_details array

  // Extract values from the first passenger (adjust the index if needed)
  const billToPassenger = passengerDetails?.find(
    (passenger) => passenger.bill_to
  );

  useEffect(() => {
    if (billToPassenger) {
      const fullName = `${billToPassenger.first_name || ""} ${
        billToPassenger.last_name || ""
      }`.trim();
      setValue("customer_details.full_name", fullName);
    }
    // Optionally, clear the full name when no matching passenger is found:
    else if (!updateData) {
      setValue("customer_details.full_name", "");
    }
  }, [billToPassenger, setValue]);

  // Render specific nested form based on the URL parameter
  const renderForm = () => {
    return (
      <>
        {currentParam === "create-new-invoice/air-ticket" && (
          <AirTicket
            airTicket={true}
            register={register}
            errors={errors}
            passengerFields={passengerFields} // Pass passengers array
            appendPassenger={appendPassenger} // Add passenger
            removePassenger={removePassenger} // Remove passenger
            flightFields={flightFields} // Pass flights array
            appendFlight={appendFlight} // Add flight
            removeFlight={removeFlight} // Remove flight
            watch={watch}
            setValue={setValue}
            control={control}
            clearErrors={clearErrors}
            getValues={getValues}
            reset={reset}
            setError={setError}
            AirTicketfromPax={true}
            AirTickettoSupplier={true}
            updateData={updateData}
            appendinsurance={appendInsurance}
            insuranceFields={insuranceFields}
            removeinsurance={removeInsurance}
          />
        )}
        {currentParam === "create-new-invoice/air-ticket" && (
          <div className="px-2">
            <button
              type="button"
              onClick={() => setInsurance(!insurance)}
              className="flex items-center rounded-full bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
            >
              {insurance ? (
                <FaMinus className="mr-1" />
              ) : (
                <FaPlus className="mr-1" />
              )}
              {insurance ? "Close" : "Add"} insurance
            </button>
          </div>
        )}

        {(currentParam === "create-new-invoice/insurance" ||
          (currentParam === "create-new-invoice/air-ticket" && insurance)) && (
          <Insurance
            insurance={true}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            insuranceFields={insuranceFields}
            appendinsurance={appendInsurance}
            removeinsurance={removeInsurance}
            control={control}
            getValues={getValues}
            clearErrors={clearErrors}
            updateData={updateData}
          />
        )}

        {currentParam === "create-new-invoice/air-ticket" && (
          <div className="mt-1 px-2">
            <button
              type="button"
              onClick={() => setLandPackage(!landPackage)}
              className="flex items-center rounded-full bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
            >
              {landPackage ? (
                <FaMinus className="mr-1" />
              ) : (
                <FaPlus className="mr-1" />
              )}
              {landPackage ? "Close" : "Add"} Land Package
            </button>
          </div>
        )}
        {(currentParam === "create-new-invoice/land-package" ||
          (currentParam === "create-new-invoice/air-ticket" &&
            landPackage)) && (
          <LandPackage
            LandPackage={true}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
            updateData={updateData}
          />
        )}

        {currentParam === "create-new-invoice/air-ticket" && (
          <div className="mt-1 px-2">
            <button
              type="button"
              onClick={() => setCruise(!cruise)}
              className="flex items-center rounded-full bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
            >
              {cruise ? (
                <FaMinus className="mr-1" />
              ) : (
                <FaPlus className="mr-1" />
              )}
              {cruise ? "Close" : "Add"} Cruise
            </button>
          </div>
        )}
        {(currentParam === "create-new-invoice/cruise" ||
          (currentParam === "create-new-invoice/air-ticket" && cruise)) && (
          <Cruise
            register={register}
            errors={errors}
            Cruise={true}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
            updateData={updateData}
          />
        )}

        {currentParam === "create-new-invoice/air-ticket" && (
          <div className="mt-1 px-2">
            <button
              type="button"
              onClick={() => setHotelForm(!hotelForm)}
              className="flex items-center rounded-full bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
            >
              {hotelForm ? (
                <FaMinus className="mr-1" />
              ) : (
                <FaPlus className="mr-1" />
              )}
              {hotelForm ? "Close" : "Add"} Hotel
            </button>
          </div>
        )}
        {(currentParam === "create-new-invoice/hotel" ||
          (currentParam === "create-new-invoice/air-ticket" && hotelForm)) && (
          <HotelForm
            register={register}
            errors={errors}
            HotelForm={true}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
            updateData={updateData}
          />
        )}
        {currentParam === "create-new-invoice/air-ticket" && (
          <div className="mt-1 px-2 pb-3">
            <button
              type="button"
              onClick={() => setMisc(!misc)}
              className="flex items-center rounded-full bg-blue-500 px-3 py-1 text-xs text-white hover:bg-blue-600"
            >
              {misc ? (
                <FaMinus className="mr-1" />
              ) : (
                <FaPlus className="mr-1" />
              )}
              {misc ? "Close" : "Add"} Misc
            </button>
          </div>
        )}
        {(currentParam === "create-new-invoice/misc" ||
          (currentParam === "create-new-invoice/air-ticket" && misc)) && (
          <Misc
            errors={errors}
            Misc={true}
            register={register}
            misc={true}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
            updateData={updateData}
          />
        )}
      </>
    );
  };

  useEffect(() => {
    const isCreatingInsuranceInvoice =
      currentParam === "create-new-invoice/insurance";

    if (isCreatingInsuranceInvoice && insuranceFields.length === 0) {
      appendInsurance({
        first_name: "",
        last_name: "",
      });
    }
  }, [currentParam]);

  useEffect(() => {
    getEmployye();
  }, []);

  useEffect(() => {
    if (!updateData) {
      setValue("sales_agent_id", userInfo.data.id);
    }
  }, [currentParam]);

  useEffect(() => {
    if (updateData) {
      if (currentParam === "create-new-invoice/air-ticket") {
        if (updateData?.insurance_include === "true") {
          setInsurance(true);
        }
        if (updateData?.land_package_include === "true") {
          setLandPackage(true);
        }
        if (updateData?.cruise_include === "true") {
          setCruise(true);
        }
        if (updateData?.hotel_include === "true") {
          setHotelForm(true);
        }
        if (updateData?.misc_include === "true") {
          setMisc(true);
        }
      }
      setValue("id", updateData?.id);
      setValue("invoice_number", updateData?.invoice_number);
      setValue("sales_agent_id", updateData?.sales_agents?.id);
      setValue("booking_date", updateData?.booking_date);
      setValue("departure_date", updateData?.departure_date);
      // setValue("travel_from", {
      //   value: updateData?.fromAirport?.id,
      //   label: updateData?.fromAirport?.name,
      // });
      // setValue("travel_to", {
      //   value: updateData?.travel_to?.id,
      //   label: updateData?.travel_to?.name,
      // });
      setValue("gds_locator", updateData?.gds_locator);
      setValue("gds_type", updateData?.gds_type);
      setValue("status", updateData?.status);
      setValue("ticket_number", updateData?.ticket_number);
      setValue("reference_no_et", updateData?.reference_no_et);
      setValue("mco", updateData?.mco);
      setValue("itinerary", updateData?.itinerary);
      if (updateData.airticket_include === "true") {
        setValue("supplier_id", Number(updateData?.supplier_id));
      }
      if (updateData.insurance_include === "true") {
        setValue(
          "insurance.insurance_supplier_id",
          Number(updateData?.insurance?.insurance_supplier_id)
        );
      }
      if (updateData.land_package_include === "true") {
        setValue(
          "land_package.land_package_supplier_id",
          Number(updateData?.land_package?.land_package_supplier_id)
        );
      }
      if (updateData.cruise_include === "true") {
        setValue(
          "cruise.cruise_supplier_id",
          Number(updateData?.cruise?.cruise_supplier_id)
        );
      }
      if (updateData.hotel_include === "true") {
        setValue(
          "hotel.hotel_supplier_id",
          Number(updateData?.hotel?.hotel_supplier_id)
        );
      }

      // for insurance passenger details
      const insurancePassengerDetails =
        updateData?.insurance?.insurance_passenger_details || [];

      // // Append missing fields if needed
      if (insuranceFields.length < insurancePassengerDetails.length) {
        // Append new passengers from the incoming data
        const newPassengers = insurancePassengerDetails.slice(
          insuranceFields.length
        );
        newPassengers.forEach((passenger) => {
          appendInsurance(passenger);
        });
      }

      // Now update each field value
      insurancePassengerDetails.forEach((passenger, index) => {
        setValue(
          `insurance.insurance_passenger_details.${index}.last_name`,
          passenger.last_name
        );
        setValue(
          `insurance.insurance_passenger_details.${index}.first_name`,
          passenger.first_name
        );
      });

      // for airline
      const passengerData = updateData?.airticket?.passenger_details || [];

      // update passenger value
      // // Append missing fields if needed
      if (passengerFields.length < passengerData.length) {
        // Append new passengers from the incoming data
        const newPassengers = passengerData.slice(passengerFields.length);
        newPassengers.forEach((passenger) => {
          appendPassenger(passenger);
        });
      }

      // Now update each field value
      passengerData.forEach((passenger, index) => {
        setValue(
          `airticket.passenger_details.${index}.last_name`,
          passenger.last_name
        );
        setValue(
          `airticket.passenger_details.${index}.first_name`,
          passenger.first_name
        );
        setValue(`airticket.passenger_details.${index}.title`, passenger.title);
        setValue(
          `airticket.passenger_details.${index}.bill_to`,
          passenger.bill_to === "true"
        );
        setValue(
          `airticket.passenger_details.${index}.add_insurance`,
          passenger.add_insurance === "true"
        );
      });

      // update flight details
      const flightData = updateData?.airticket?.flight_details || [];

      // Append any missing flight fields to match incoming data length
      if (flightFields.length < flightData.length) {
        const newFlights = flightData.slice(flightFields.length);
        newFlights.forEach((flight) => {
          appendFlight(flight);
        });
      }

      // Update each flight detail field
      flightData.forEach((flight, index) => {
        setValue(`airticket.flight_details.${index}.airline`, flight.airline);
        setValue(`airticket.flight_details.${index}.from`, flight.from);
        setValue(`airticket.flight_details.${index}.to`, flight.to);
        setValue(`airticket.flight_details.${index}.date`, flight.date);
        setValue(
          `airticket.flight_details.${index}.flight_no`,
          flight.flight_no
        );
        setValue(`airticket.flight_details.${index}.dep_time`, flight.dep_time);
        setValue(`airticket.flight_details.${index}.arr_time`, flight.arr_time);
      });

      // update customer datails
      setValue("customer_id", updateData?.customer_id);
      setValue(
        "customer_details.full_name",
        updateData?.customer_details?.full_name
      );
      setValue("customer_details.email", updateData?.customer_details?.email);
      setValue(
        "customer_details.phone_number",
        updateData?.customer_details?.phone_number
      );
      setValue(
        "customer_details.alternate_phone",
        updateData?.customer_details?.alternate_phone
      );
      setValue(
        "customer_details.address",
        updateData?.customer_details?.address
      );
      setValue(
        "customer_details.country_id",
        Number(updateData?.customer_details?.country_id)
      );
      setValue(
        "customer_details.state_id",
        Number(updateData?.customer_details?.state_id)
      );
      setValue(
        "customer_details.city_id",
        Number(updateData?.customer_details?.city_id)
      );

      setValue(
        "customer_details.postal_code",
        updateData?.customer_details?.postal_code
      );
      setValue(
        "customer_details.passport_number",
        updateData?.customer_details?.passport_number
      );
    }
  }, [updateData]);

  return (
    <section>
      <div className="mt-0 sm:mt-4 ">
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          {/* Invoice Details */}
          {currentParam !== "create-new-invoice/misc" && (
            <div className="rounded-lg bg-gray-900 p-2 shadow-xl ">
              <h2 className="text-lg font-semibold text-[#09c8ff]">
                Invoice Details
              </h2>
              <div className="grid grid-cols-2 gap-x-2 sm:grid-cols-3 md:grid-cols-4">
                <InputField
                  label="Invoice Number"
                  id="invoice_number"
                  type="text"
                  placeholder="New Invoice"
                  register={register}
                  disabled={true}
                  name="invoice_number"
                  errorMessage={errors?.invoice_number?.message}
                  onChange={() => clearErrors("invoice_number")}
                  bgAllDark={true}
                />
                <InputField
                  label="Booking Date"
                  id="booking_date"
                  type="date"
                  register={register}
                  name="booking_date"
                  rules={{ required: "Booking Date is required" }}
                  errorMessage={errors?.booking_date?.message}
                  onChange={() => clearErrors("booking_date")}
                  bgAllDark={true}
                />
                <div>
                  <label className="my-2 block text-sm  font-medium text-[#09c8ff]">
                    Sales Agent
                  </label>
                  <Select
                    {...register(`sales_agent_id`, {
                      required: "Please select a user to assign this enquiry.",
                    })}
                    value={employeeData.find(
                      (option) => option.value === watch("sales_agent_id") // Use watch to get the current value from React Hook Form
                    )} // Controlled value
                    onChange={(selectedOption) => {
                      setValue("sales_agent_id", selectedOption?.value || ""); // Update the value using setValue from React Hook Form
                      clearErrors("sales_agent_id");
                    }}
                    options={employeeData} // Format options
                    isDisabled={false}
                    isSearchable={true}
                    placeholder="Select..."
                    classNames={getSelectClassNames({
                      isDisabled: false,
                      selectProps: {},
                      isSelected: false,
                      value: watch("sales_agent_id"),
                    })}
                    formatOptionLabel={(data) => (
                      <li
                        className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                          !data.isSelected
                            ? `bg-gray-200 text-gray-900`
                            : `bg-blue-800 text-gray-200`
                        }`}
                      >
                        {data.label}
                      </li>
                    )}
                  />
                </div>
                <InvoiceDetailsForm
                  register={register}
                  errors={errors}
                  watch={watch}
                  setValue={setValue}
                  control={control}
                  clearErrors={clearErrors}
                  updateData={updateData}
                />
              </div>
            </div>
          )}

          <div>
            <CustomerDetails
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              watch={watch}
              setValue={setValue}
              control={control}
              getValues={getValues}
            />
          </div>
          {/* Nested list */}
          <div className="hide-scroll-bar mt-2 flex gap-2 overflow-scroll sm:gap-5">
            {ticketItems.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                className={`cursor-pointer whitespace-nowrap border ${
                  "/admin/" + currentParam === item.link
                    ? "bg-gray-900 font-semibold text-white"
                    : "bg-white text-gray-900"
                } border-b-0  border-gray-900 px-4  py-1 outline-none hover:border-gray-900 hover:bg-gray-900 hover:text-white`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Dynamic Nested Form */}
          <div className="bg-gray-900 shadow-xl">{renderForm()}</div>
          {/* documentation  */}
          {currentParam !== "create-new-invoice/misc" && (
            <div>
              <Documentation
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                control={control}
                clearErrors={clearErrors}
                updateData={updateData}
              />
            </div>
          )}

          {/* Submit Button */}
          <div className="col-span-1 sm:col-span-2">
            <button
              type="submit"
              className={`w-full ${
                disable
                  ? "cursor-not-allowed bg-gray-300"
                  : "cursor-pointer bg-[#09c8ff] hover:bg-[#058cb3]"
              }  py-3 text-white  `}
              disabled={disable}
            >
              {updateData ? "Update invoice" : "Create Invoice"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
